class LanguageSwitcher {
    constructor(element) {
        this.container = element;
        this.button = this.container.querySelector('.language-switcher__current');

        this.bindEvents();
    }

    bindEvents() {
        this.button.addEventListener('click', (e) => {
            e.stopPropagation();

            document
                .querySelectorAll('.language-switcher.is-open')
                .forEach((item) => {
                    if (item !== this.container) {
                        item.classList.remove('is-open');
                    }
                });

            this.container.classList.toggle('is-open');
        });

        this.container.addEventListener('click', (e) => {
            e.stopPropagation();
        });
    }

    static init() {
        document.addEventListener('click', () => {
            document
                .querySelectorAll('.language-switcher.is-open')
                .forEach((item) => item.classList.remove('is-open'));
        });

        document
            .querySelectorAll('.language-switcher')
            .forEach((element) => new LanguageSwitcher(element));
    }
}

LanguageSwitcher.init();